<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->

    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/ruike/label/detail/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item class="noborder" :label="$t('dairukudanhao')">
            <el-input disabled v-model="$attrs.receiptDetails.no"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('kucunzuzhi')">
            <el-input disabled v-model="$attrs.receiptDetails.inventoryOrg"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('shengchangongdanhao')">
            <el-input disabled v-model="$attrs.labelDetails.woNo"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')">
            <el-input disabled :value="$attrs.labelDetails.material.code+'/'+$attrs.labelDetails.material.name"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('picihao')">
            <el-input disabled v-model="$attrs.labelDetails.batchNo"></el-input>
          </el-form-item>
          <el-form-item>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger"
              @click="yt.remove(scope.row,'/custom/ruike/label/detail/delete')">{{$t('shanchu')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
  export default {
    name: 'web_production_management_pending_receipt_rk_receipt_details',
    components: {
      // work_bom
    },
    data() {
      return {
        materialIdlist: [],
        materialIds: null,
        planIdList: [],
        planId: null,
        columns: [
          {
            label: 'biaoqiantiaoma',
            prop: 'labelBarcodeNo',
            width: 180
          },
          {
            label: 'yewuleixing',
            prop: 'printRecord.businessType',
            type: 'dictionary',
            key: 'BUSINESS_TYPE',
            width: 150
          },
          {
            label: 'dayinren',
            prop: 'printedByObject.nickname',
            width: 130
          },
          {
            label: 'dayinshijian',
            prop: 'printTime',
            type: 'time',
            width: 180
          },
          {
            label: 'shengchangongdanhao',
            prop: 'woNo',
            width: 150
          },
          {
            label: 'ERPgongdanhao',
            prop: 'erpNo',
            width: 150
          },
          {
            label: 'baozhuangshuliang',
            prop: 'printRecord.packageNumber',
            width: 130
          },
          {
            label: 'biaoqianzongshu',
            prop: 'printRecord.labelTotalNumber',
            width: 130
          },
          {
            label: 'dangqianshunxu',
            prop: 'printRecord.currentOrder',
            width: 130
          },
          {
            label: 'picihao',
            prop: 'printRecord.batchNo',
            width: 180
          },{
            label: 'yibaogongliangpinshu',
            prop: 'goodQuantity',
            width: 130
          },
          {
            label: 'shengchanzhuangtai',
            prop: 'printRecord.productionStatus',
            type: 'dictionary_tag',
            key: 'LABEL_PRODUCTION_STATUS'
          },
          {
            label: 'zhijianzhuangtai',
            prop: 'printRecord.qualityCheckStatus',
            type: 'dictionary_tag',
            key: 'LABEL_QUALITY_CHECK_STATUS'
          },
          {
            label: 'rukuzhuangtai',
            prop: 'printRecord.storageStatus',
            type: 'dictionary_tag',
            key: 'LABEL_STORAGE_STATUS'
          },
          {
            label: 'youxiaozhuangtai',
            prop: 'printRecord.validStatus',
            type: 'dictionary_tag',
            key: 'LABEL_VALID_STATUS'
          },

          {
            label: 'caozuo',
            type: 'slot',
            width: 130,
            fixed: 'right'
          },
        ]
      };
    },

    created() {
      setTimeout(() => {
        this.yt.conditions = {
          pendingReceiptDetailId: this.$attrs.labelDetails.id,
        };
        this.yt.get(1);
      }, 300);
    },
    methods: {
      selectionChange(items) {
        this.planIdList = items.map(item => {
          return item.id;
        });
        this.planId = items
          .map(item => {
            return item.no;
          })
          .join(',');
      },
      getItems(items) {
        this.materialIdlist = items;

        for (let i = 0; i < this.materialIdlist.length; i++) {
          this.materialId = this.materialIdlist[i]['id'];
        }
        console.log('this.materialId', this.materialId);
      }
    }
  };
</script>
